import { adjustColor, adjustColorToLightOrDark } from 'utils/colorUtils';
import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import constants from 'constants/index';

const getIconClass = (source, resType, customIcon) => {
  if (customIcon) return customIcon;

  if (source === 'google_calendar') return 'fab fa-google';

  switch (resType) {
    case 'user':
      return 'fas fa-birthday-cake';
    case 'case':
      return 'fas fa-briefcase';
    case 'task':
      return 'fas fa-tasks';
    case 'event':
      return 'far fa-calendar-alt';
    case 'outlook':
      return 'fab fa-microsoft';
    default:
      return 'far fa-calendar-alt';
  }
};

const getColors = (source, resType, calendarColorRaw) => {
  if (calendarColorRaw && source !== 'google_calendar') {
    const background = adjustColor(calendarColorRaw, 70);
    return {
      borderColor: calendarColorRaw,
      backgroundColor: background,
      textColor: adjustColorToLightOrDark(background),
      iconBgColor: calendarColorRaw,
    };
  }

  if (resType === 'user' || resType === 'case') {
    return {
      borderColor: '#F0F2F5',
      backgroundColor: '#F0F2F5',
      textColor: '#7F8F9F',
      iconBgColor: '#7F8F9F',
    };
  }

  return {
    borderColor: '#2655b9',
    backgroundColor: '#f5f5fa',
    textColor: '#2655b9',
    iconBgColor: '#2655b9',
  };
};

const EventContent = ({ event, view }) => {
  const { startStr, endStr, allDay, title, _context, _def } = event || {};
  const { dateEnv } = _context || {};
  const timezone = dateEnv?.timeZone;
  const {
    res_type: resType,
    source,
    event_type,
    firm_users,
    calendar_color,
    created_by_details,
    firm_wide,
    conference_room_id,
    conference_room,
    room_name,
  } = _def?.extendedProps || {};

  const icon = firm_wide ? 'fas fa-users' : getIconClass(source, resType, event_type?.event_type_icon);
  const calendarColor = firm_wide
    ? '#ea580c'
    : firm_users?.[0]?.calendar_color || calendar_color || created_by_details?.calendar_color || '';

  const { borderColor, backgroundColor, textColor, iconBgColor } = getColors(source, resType, calendarColor);
  const borderLeftStyle = `4px solid ${borderColor}`;

  const startDate = handleDateTimeOffset(timezone, startStr, constants.hour_minute_12_format);
  const endDate = endStr ? handleDateTimeOffset(timezone, endStr, constants.hour_minute_12_format) : startDate;

  // Check if event has a conference room
  const hasConferenceRoom = conference_room_id || conference_room || room_name;

  const isTimeGrid = view.type.includes('timeGrid');
  const showTime = ['event', 'google', 'outlook'].includes(resType);

  const showIcon = () => {
    if (!isTimeGrid) return true;

    if (new Date(endStr) - new Date(startStr) <= 1800000) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <div className="badgeevent-wrapper" style={{ width: '100%', height: '100%' }}>
      <div
        className="badge-events d-flex"
        style={{
          background: backgroundColor,
          borderLeft: borderLeftStyle,
          color: textColor,
          height: '100%',
          minHeight: isTimeGrid ? '' : '50px',
        }}
      >
        {showIcon() && (
          <div className="badge-event-icon me-2" style={{ backgroundColor: iconBgColor }}>
            <i className={icon} style={{ color: textColor }} />
          </div>
        )}

        <div className={`badge-event-details ${!showIcon() ? 'event-name-flex' : ''}`} title={`${startDate} - ${endDate}`}>
          {showTime && (
            <div className="time">
              <span>{allDay ? 'All Day' : `${startDate} - ${endDate}`}</span>
            </div>
          )}
          <div className="title" title={title}>
            <span className="text-break title">{title}</span>
          </div>
        </div>

        {hasConferenceRoom && (
          <div className="badge-event-conference-room ms-auto d-flex align-items-center">
            <div
              style={{
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <i className="fas fa-map-marker-alt" style={{ color: '#4a5568', fontSize: '10px' }}></i>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventContent;
